// extracted by mini-css-extract-plugin
export default {"navlinks":"NavBar_navlinks__wREke","active":"NavBar_active__kAodX"};